<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@inventoryReportDialog-Title">Inventory Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="inventory-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>
	<mat-dialog-content class="drawer-dialog-content">
		<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-devices">Devices</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="devices-typeahead"
				[allDropdownOptions]="deviceOptions"
				[filterOnField]="'serialNumber'"
				[placeholderText]="this.deviceMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="deviceId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		@if (isCareCompany) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNameOptions"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNameOptions"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdnOptions"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>
		}

		<div>
			<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-property">Property</h3>
			<app-loading-indicator
				[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
				diameter="30"
			>
				<app-multi-select-typeahead
					data-automation-id="property-typeahead"
					[allDropdownOptions]="propertiesOptions"
					[filterOnField]="'propertyName'"
					[placeholderText]="this.devicePropertyMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-lock'"
					[initiallySelectedItemIds]="propertyIds"
					[initiallySelectedIdField]="'propertyName'"
					[minCharactersForSearch]="3"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
					(searchInputChanged)="onSearchInput('property', $event)"
				>
				</app-multi-select-typeahead>
			</app-loading-indicator>
			<mat-divider></mat-divider>
		</div>

		<div>
			<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-installationLocation">
				Installation Location
			</h3>
			<app-loading-indicator
				[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
				diameter="30"
			>
				<app-multi-select-typeahead
					data-automation-id="installation-location-typeahead"
					[allDropdownOptions]="locationInstallationOptions"
					[filterOnField]="'locationInstallationName'"
					[placeholderText]="this.installationLocationMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-lock'"
					[initiallySelectedItemIds]="installationNames"
					[initiallySelectedIdField]="'locationInstallationName'"
					[minCharactersForSearch]="3"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('installationLocation', $event)"
					(searchInputChanged)="onSearchInput('installationLocation', $event)"
				>
				</app-multi-select-typeahead>
			</app-loading-indicator>
			<mat-divider></mat-divider>
		</div>

		<div>
			<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-postalCodes">Postal Codes</h3>
			<app-loading-indicator
				[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
				diameter="30"
			>
				<app-multi-select-typeahead
					data-automation-id="postal-codes-typeahead"
					[allDropdownOptions]="postalCodeOptions"
					[filterOnField]="'postalCode'"
					[placeholderText]="this.postalCodeMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-lock'"
					[initiallySelectedItemIds]="postalCodes"
					[initiallySelectedIdField]="'postalCode'"
					[minCharactersForSearch]="3"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('postalCode', $event)"
					(searchInputChanged)="onSearchInput('postalCode', $event)"
				>
				</app-multi-select-typeahead>
			</app-loading-indicator>
			<mat-divider></mat-divider>
		</div>

		<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-status">Status</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="status-typeahead"
				[allDropdownOptions]="statusOptions"
				[filterOnField]="'status'"
				[placeholderText]="this.statusPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[initiallySelectedItemIds]="statuses"
				[initiallySelectedIdField]="'status'"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('status', $event)"
				(searchInputChanged)="onSearchInput('status', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-dateGenerated">Timeframe</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@inventoryReportDialog-startDateGenerated">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateGeneratedStartPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@inventoryReportDialog-chooseStartDateGenerated"
					(dateChange)="onStartDateChanged($event)"
					[ngModel]="this.inventoryReportFilters.startDate"
					data-automation-id="start-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateGeneratedStartPicker"
					data-automation-id="start-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateGeneratedStartPicker data-automation-id="start-date-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@inventoryReportDialog-endDateGenerated">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateGeneratedEndPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@inventoryReportDialog-ChooseEndDateGenerated"
					(dateChange)="onEndDateChanged($event)"
					[ngModel]="this.inventoryReportFilters.endDate"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateGeneratedEndPicker"
					data-automation-id="end-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateGeneratedEndPicker data-automation-id="end-date-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>

		<mat-divider class="no-margin-bottom"></mat-divider>

		<div>
			<div
				class="show-advanced-filters-container"
				(click)="this.inventoryReportFilters.showAdvancedFilters = !this.inventoryReportFilters.showAdvancedFilters"
			>
				<h3 class="show-advanced-filters-title" i18n="@@inventoryReportDialog-advancedFilters">
					Show Advanced Filters
				</h3>
				@if (!this.inventoryReportFilters.showAdvancedFilters) {
					<mat-icon svgIcon="sl-down-caret" class="show-advanced-filters-arrow"></mat-icon>
				}
				@if (!!this.inventoryReportFilters.showAdvancedFilters) {
					<mat-icon svgIcon="sl-up-caret" class="show-advanced-filters-arrow"></mat-icon>
				}
			</div>

			<div [ngClass]="{ 'hidden-container': !this.inventoryReportFilters.showAdvancedFilters }">
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-deviceGroups">Device Groups</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="device-groups-typeahead"
						[allDropdownOptions]="deviceGroupOptions"
						[filterOnField]="'name'"
						[placeholderText]="this.deviceGroupMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="deviceGroupIds"
						[initiallySelectedIdField]="'id'"
						[minCharactersForSearch]="3"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceGroup', $event)"
						(searchInputChanged)="onSearchInput('deviceGroup', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				i18n="@@inventoryReportDialog-closeWindow"
				(click)="onCloseDialog()"
				data-automation-id="inventory-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="inventory-generate-report-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
